import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import "./Mint.css"

import carousel4 from "../../Images/carousel4.jpg"
function Mints() {
    return (
        <>
            <div className="container mint" id="mints">

                <div className="mint_inner">
                    <div className="carossy">
                        <Link to="/mint" target="./blank" className="linkedsy">


                            <div className="story_discordsy">
                                <p className="story_joinsy">Connect Wallet</p>
                            </div></Link>
                        <br /><br />
                        <img src={carousel4} className="carosy" />




                    </div>


                </div><br />
                <div>

                    <h1 className="mint_one">
                        Each of the Solarbear's (x amount) traits are handdrawn by CartoonDoctor
                        (<a className="anker_tag" target="_blank" href="https://twitter.com/Cartoon_Doctor">"CartoonDoctor"</a>)
                        and carefully designed in a way to improve randomness aesthetics.
                    </h1>
                </div>

            </div>
        </>
    )
}

export default Mints
